export * from './full-layout.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/containers/full-layout/index.ts